import { TeBadge, TeIcon } from '@topcon/tuicl-react';
import { borderRadiusToPixelString } from '@topcon/tuicl/dist/common/utils';
import styled from 'styled-components';

import { ThemeColor } from '../../../providers/theme/theme.types';
import { getThemeColorValue } from '../../../providers/theme/theme.index';

const BadgeWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

const StyledBadge = styled(TeBadge)<{
  borderColor: ThemeColor;
  backgroundColor?: string;
  icon?: boolean;
}>`
  border: 1px solid ${(props) => getThemeColorValue(props.borderColor)};
  border-radius: ${borderRadiusToPixelString('m')};
  background-color: ${(props) => getThemeColorValue(props.backgroundColor as ThemeColor)};

  /* Reserve space for the icon */
  padding-left: ${(props) => (props.icon ? '16px' : '0px')};
`;

const StyledIcon = styled(TeIcon)`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
`;

type CustomBadgeProps = React.ComponentProps<typeof TeBadge> & {
  borderColor: ThemeColor;
  icon?: string;
};

export default function CustomBadge({
  icon,
  borderColor,
  backgroundColor,
  textColor,
  children,
  ...badgeProps
}: CustomBadgeProps) {
  return (
    <BadgeWrapper>
      {icon && <StyledIcon name={icon} size="s" color={textColor} />}
      <StyledBadge
        borderColor={borderColor}
        backgroundColor={backgroundColor}
        textColor={textColor}
        icon={!!icon}
        {...badgeProps}
      >
        {children}
      </StyledBadge>
    </BadgeWrapper>
  );
}
